import styles from "./VkShareTask.module.scss";
import { VkShareItem } from './VkShareItem';
import { useSelector } from "../../../../hooks";
import { ContentWrapper } from '../../../../components/ContentWrapper/ContentWrapper';
import { PageTitleBlock } from '../../../../components/PageTitleBlock/PageTitleBlock';
import { CardWrapper } from '../../../../components/CardWrapper/CardWrapper';
import { ITaskReward } from "../../../../components/TaskCard/TaskCard";

export class VkShareTaskDto {
    taskId!: number;
    title!: string;
    link!: string;
    description!: string;
    image!: string;
    reward!: ITaskReward;
    performDate!: number;
    cooldown!: number;
    pendingTime!: number;
    lastRewardDate!: number;
}

export const VkShareTaskPage = () => {
    const vkShareTasks = useSelector(store => store.tasks.vkShareTasks)
    
    return (
        <ContentWrapper>
            <div className={styles.tasksWrapper}>
                <PageTitleBlock
                    pageTitle={"Разместить пост в ВК"}
                    pageDescription={ "Вы пост, мы рублики — сделка века!" }
                />

                <CardWrapper>
                {
                    vkShareTasks && vkShareTasks.map((task, index) => {
                        return (
                            <VkShareItem
                                key={ `vkShareTask${task.link}` }
                                task={ task }
                                index={ index }
                            />
                        );
                    })
                }
                </CardWrapper>
            </div>
        </ContentWrapper>
    );
};